import React, { useRef, useState } from "react";
import styled from "styled-components";

import CameraFeedback from "../../assets/icons/camera-icon.svg";

import {
    Overlay,
    Modal,
    CloseButton,
    Title,
    Buttons,
    ModalButton
} from "./styles";

interface CameraModalProps {
  onClose: () => void;
}

export function CameraModal({ onClose }: CameraModalProps) {
  const videoRef = useRef<HTMLVideoElement>(null);
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const mediaRecorderRef = useRef<MediaRecorder | null>(null);
  const [isRecording, setIsRecording] = useState(false);
  const [recordedChunks, setRecordedChunks] = useState<Blob[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [recordingTime, setRecordingTime] = useState(0);
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  const startCamera = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: "user" },
        audio: true,
      });

      if (videoRef.current) {
        videoRef.current.srcObject = stream;
      }
    } catch (error) {
      console.error("Erro ao acessar câmera:", error);
      alert("Não foi possível acessar a câmera do dispositivo");
    }
  };

  
  const startRecording = () => {
    const stream = videoRef.current?.srcObject as MediaStream;
    
    if (!stream) {
      alert("Câmera não inicializada");
      return;
    }

    const chunks: Blob[] = [];
    const mediaRecorder = new MediaRecorder(stream, {
      mimeType: "video/webm;codecs=vp9",
    });

    mediaRecorder.ondataavailable = (event) => {
      if (event.data.size > 0) {
        chunks.push(event.data);
      }
    };

    mediaRecorder.onstop = () => {
      setRecordedChunks(chunks);
    };

  setRecordingTime(0);
  timerRef.current = setInterval(() => {
    setRecordingTime((prev) => prev + 1);
  }, 1000);

    mediaRecorderRef.current = mediaRecorder;
    mediaRecorder.start();
    setIsRecording(true);
  };

  
  const stopRecording = () => {
    if (mediaRecorderRef.current) {
      mediaRecorderRef.current.stop();
      setIsRecording(false);

      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
    }
  };

  // função enviar video mockada 
  // const sendVideo = async () => {
  //   if (recordedChunks.length === 0) {
  //     alert("Nenhum vídeo gravado");
  //     return;
  //   }

  //   setIsLoading(true);
  //   const videoBlob = new Blob(recordedChunks, { type: "video/webm" });
  //   const formData = new FormData();
  //   formData.append("video", videoBlob, "feedback.webm");

  //   try {
  //     const response = await fetch("/api/send-feedback", {  rota generica da API
  //       method: "POST",
  //       body: formData,
  //     });

  //     if (response.ok) {
  //       alert("Vídeo enviado com sucesso!");
  //       resetAndClose();
  //     } else {
  //       alert("Erro ao enviar vídeo");
  //     }
  //   } catch (error) {
  //     console.error("Erro ao enviar vídeo:", error);
  //     alert("Erro na conexão");
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

 
  const resetAndClose = () => {
    const stream = videoRef.current?.srcObject as MediaStream;
    if (stream) {
      stream.getTracks().forEach((track) => track.stop());
    }
    setRecordedChunks([]);
    setIsRecording(false);
    onClose();
  };

  
  React.useEffect(() => {
    startCamera();
    return () => {
      const stream = videoRef.current?.srcObject as MediaStream;
      if (stream) {
        stream.getTracks().forEach((track) => track.stop());
      }
    };
  }, []);

  function handleOverlayClick(e: React.MouseEvent<HTMLDivElement>) {
    if (e.target === e.currentTarget) resetAndClose();
  }
  const formatTime = (seconds: number) => {
  const m = Math.floor(seconds / 60).toString().padStart(2, "0");
  const s = (seconds % 60).toString().padStart(2, "0");
  return `${m}:${s}`;
};

  return (
    <Overlay onClick={handleOverlayClick}>
      <Modal>
        <CloseButton onClick={resetAndClose} aria-label="Fechar modal">×</CloseButton>
        <Title>Enviar vídeo</Title>
        <div className="square">
          <video
            ref={videoRef}
            autoPlay
            playsInline
            muted
            className="camera-modal"
            style={{ width: "100%", borderRadius: "8px" }}
          />
          {isRecording && (
            <div className="RecordingIndicator" style={{color: "red"}}>
              ● Gravando ({formatTime(recordingTime)})
            </div>
          )}
        </div>
        <Buttons>
          {!isRecording && recordedChunks.length === 0 && (
            <ModalButton onClick={startRecording}>Iniciar Gravação</ModalButton>
          )}
          {isRecording && (
            <ModalButton onClick={stopRecording} style={{ backgroundColor: "#e74c3c" }}>
              Parar Gravação
            </ModalButton>
          )}
          {recordedChunks.length > 0 && !isRecording && (
            <ModalButton  disabled={isLoading}>  {/* onClick={sendVideo} */}
              {isLoading ? "Enviando..." : "Enviar"}
            </ModalButton>
          )}
          <ModalButton onClick={resetAndClose}>Cancelar</ModalButton>
        </Buttons>
      </Modal>
    </Overlay>
  );
}